import { ActionIcon } from '@mantine/core';
import { openContextModal } from '@mantine/modals';
import { IconPlayerPlay } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './VideoTutorialButton.module.scss';
import { Props } from './VideoTutorialButton.types';

const VideoTutorialButton = ({ videoUrl }: Props) => {
  const { t } = useTranslation();

  const openVideoModal = () => {
    openContextModal({
      modal: 'videoTutorial',
      title: 'Tutoriel vidéo',
      innerProps: {
        videoUrl,
      },
      size: 'xl',
    });
  };

  return (
    <button type="button" className={styles.wrapper} onClick={openVideoModal}>
      <ActionIcon
        variant="filled"
        color="orange"
        radius="xl"
        size="lg"
        component="span"
        className={styles.button}
      >
        <IconPlayerPlay size={20} />
      </ActionIcon>
      <span className={styles.label}>{t('common.videoHelp', 'Aide vidéo')}</span>
    </button>
  );
};

export default VideoTutorialButton;
